import { Controller } from "@hotwired/stimulus"

export default class AdminBundleItemController extends Controller {
  remove(event) {
    const packageItem = event.target.closest(".package-item")
    packageItem.remove()
  }
}